'use client';

import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;

if (!SENTRY_DSN) {
  console.warn('NEXT_PUBLIC_SENTRY_DSN is not set. Error tracking will be disabled.');
}

// Only initialize if we have a DSN
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    // Enable debug in development
    debug: process.env.NODE_ENV !== 'production',
    // Adjust this value in production
    tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
    // Don't send PII by default
    sendDefaultPii: true,
    // Add useful integrations
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.feedbackIntegration({
        colorScheme: "system",
        isNameRequired: true,
      }),
    ],
    beforeSend(event) {
      // Log the event in development
      if (process.env.NODE_ENV !== 'production') {
        console.log('Sending event to Sentry:', {
          eventId: event.event_id,
          level: event.level,
          message: event.message,
        });
      }
      return event;
    },
  });
}

export { Sentry }; 